import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { buildQueryString } from '../../utils/query-params.utils';
import { ConfigService } from '../config-service/config-service.service';
import { withSecureHeaders } from '../metadata-service/otp-utils';
import {
  CompaniesHouseNumberResult,
  CompaniesHouseSearchResponse,
} from '@finxone-platform/shared/sys-config-types';

@Injectable({
  providedIn: 'root',
})
export class CompaniesHouseService {
  private baseUrl = '';

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.configService.getApi('metadata_service').subscribe((api) => {
      this.baseUrl = api;
    });
  }

  searchCompanies(params: {
    companyName?: string;
    location?: string;
    includeMetadata?: boolean;
    page?: number;
    limit?: number;
  }): Observable<CompaniesHouseSearchResponse> {
    params = {
      ...params,
      includeMetadata: true,
    };
    return withSecureHeaders(this.http, this.baseUrl, (headers) =>
      this.http
        .get<CompaniesHouseSearchResponse>(
          `${this.baseUrl}/company-check/search/companies${buildQueryString(params)}`,
          { headers },
        )
        .pipe(
          catchError((_err) => {
            console.error(`Error searching companies: ${JSON.stringify(_err)}`);
            throw _err;
          }),
        ),
    );
  }

  checkCompanyNumber(companyNumber: string): Observable<CompaniesHouseNumberResult> {
    return withSecureHeaders(this.http, this.baseUrl, (headers) =>
      this.http
        .get<CompaniesHouseNumberResult>(
          `${this.baseUrl}/company-check/${companyNumber}?includeMetadata=true`,
          { headers },
        )
        .pipe(
          catchError((_err) => {
            console.error(`Error checking company number: ${JSON.stringify(_err)}`);
            throw _err;
          }),
        ),
    );
  }
}
